<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap" *ngIf="isLoaded">
    <div class="app-l-user-details">
        <div class="app-l-user-details_date">
            {{ date | date: 'MMM d, y, EEE' }}
            <div class="icon">
                <svg-icon
                    icon="notificationIcon"
                    alt="notificationIcon"></svg-icon>
            </div>
        </div>
    </div>
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            [routerLink]="['/professional/users']">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul>
                <li translate>
                    <a [routerLink]="['/professional/users']" translate
                        >menu.clientList</a
                    >
                </li>
                <li class="app-l-current-page" translate>
                    {{ user?.fullName }}
                </li>
            </ul>
        </div>
    </div>
    <div class="app-c-card app-l-action-plan-preview-body app-l-user-details__card">
        <div class="app-l-room__pos">
            <div class="app-l-room__tabs">
                <my-tabs
                   
                    #tabGroup
                    (tabChange)="onTabChanged($event)"
                                    >
                    <my-tab [tabTitle]="'OverView'">
                        <ng-template #myTabTitle><span>Overview</span></ng-template>
                        <app-user-details-overview
                            #userDetailsOverviewComp
                            *ngIf="user && userDetailOverview"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userActionPlans]="userActionPlans"
                            [userDetail]="user"></app-user-details-overview>
                    </my-tab>
                    <my-tab [tabTitle]="'Assessment'">
                        <ng-template #myTabTitle>
                            <span>Assessment</span>
                        </ng-template>
                        <app-assessment-view
                            #userDetailsAssessmentComp
                            *ngIf="user && assessmentView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userDetail]="user"></app-assessment-view>
                    </my-tab>
                    <my-tab [tabTitle]="'Moodcheck'">
                        <ng-template #myTabTitle>
                            <span>Moodcheck</span>
                        </ng-template>
                        <app-moodcheck-view
                            #userDetailsMoodcheckComp
                            *ngIf="user && moodcheckView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userDetail]="user"></app-moodcheck-view>
                    </my-tab>
                    <my-tab [tabTitle]="'Series'">
                        <ng-template #myTabTitle>
                            <span>Series</span>
                        </ng-template>
                        <app-user-details-series
                            #userDetailsSeriesComp
                            *ngIf="user && seriesView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userDetail]="user"></app-user-details-series>
                    </my-tab>
                    <my-tab [tabTitle]="'OrgOwnContent'"  *ngIf="enableOrganizationOwnContents">
                        <ng-template #myTabTitle>
                            <span>Organization’s Own Content</span>
                        </ng-template>
                        <app-user-org-own-content
                            #userDetailsSeriesComp
                            *ngIf="user && orgContentView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userDetail]="user"></app-user-org-own-content>
                    </my-tab>
                    <my-tab [tabTitle]="'Actionplan'">
                        <ng-template #myTabTitle>
                            <span>Action Plan</span>
                        </ng-template>
                        <app-action-plan-view
                            #userDetailsActionPlanComp
                            *ngIf="user && actionplanView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userActionPlans]="userActionPlans"
                            [userDetail]="user"></app-action-plan-view>
                    </my-tab>
                    <my-tab [tabTitle]="'Tools'">
                        <ng-template #myTabTitle>
                            <span>Tools</span>
                        </ng-template>
                        <app-tools-view
                            #userDetailsToolsComp
                            *ngIf="user && toolsView"
                            [countData]="countData"
                            [demographicData]="demographicDetail"
                            [userDetail]="user"></app-tools-view>
                    </my-tab>
                </my-tabs>
            </div>
            <!-- <div *ngIf="filteredItems.length <= 0">
                    <div class="empty-card">
                        <div class="app-dm-positive-cards"
                            [translate]="!this.isLoading ? 'actionPlan.noDataFound' : ''">
                        </div>
                    </div>
                </div> -->
        </div>
    </div>
</div>
